@import 'styles/mixins';
@import 'styles/blaze/mixins';

.actionWrapper {
  width: 100%;
}

.action {
  @include md-sohne-medium;
  color: var(--dark-90);
  line-height: 20px;
  justify-content: flex-start;
  width: 100%;
  min-height: 44px;
  padding: 8px 10px;
  column-gap: 10px;
  border-radius: 8px;

  [data-autopilot-system-redesign='on'] & {
    @include md-sohne;
    height: 36px;
    min-height: 36px;
    padding: 9px;
    border-radius: 8px;
    column-gap: 8px;
  }

  &:hover {
    background: var(--light-40);
    box-shadow: 0px 0px 8px 0px var(--dark-8);

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
    }
  }

  .icon {
    display: flex;
    padding: 0;
    align-items: flex-start;
    justify-content: center;
    gap: 10px;
    border-radius: 33px;
    border: none;
    width: 36px;
    height: fit-content;

    [data-autopilot-system-redesign='on'] & {
      width: 18px;
      height: 18px;
      border-radius: 0;

      path {
        stroke-width: 1.15;
      }
    }
  }
}

.actionTooltip {
  display: flex;
  max-width: 224px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: var(--white, #fff);
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.12px;
}

.calendarPopover {
  width: 280px;
  padding: 8px;
}

.upgradeBadgeContainer {
  position: absolute;
  top: 12px;
  right: 5px;
}
